import React from 'react';
import { Field } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import i18n from 'i18n-js';

import {
  RenderInput,
  RenderTextarea,
  RenderProfileImagePicker,
} from '../FieldRenderer/index';

import styles from './createUserForm.css';

const ParentForm = () => (
  <Grid>
    <Row>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label={i18n.t('labels.name', { count: 1 })}
          name="first_name"
          component={RenderInput}
          placeholder="Ej.: Mario"
        />
      </Col>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label="Apellido:"
          name="last_name"
          component={RenderInput}
          placeholder="Ej.: Subuyuj"
        />
      </Col>
    </Row>
    <Row>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label="Teléfono:"
          name="phone"
          component={RenderInput}
          placeholder="Ej.: 42491094"
        />
      </Col>
      <Col className={styles.input} xs={6}>
        <Field
          type="text"
          label="Email:"
          name="email"
          component={RenderInput}
          placeholder="Ej.: test@edoo.io"
        />
      </Col>
    </Row>
    <Row>
      <Col className={styles.input} xs={6}>
        <Field
          name="address"
          label="Dirección:"
          component={RenderTextarea}
        />
      </Col>
      <Col className={`${styles.input} ${styles.imageSelectorContainer}`} xs={6}>
        <Field name="profile_picture" component={RenderProfileImagePicker} />
      </Col>
    </Row>
    <br/>
    <br/>
  </Grid>
);

export default ParentForm;



// WEBPACK FOOTER //
// ./src/scripts/components/CreateUserForm/ParentForm.jsx